<p>{{ title }}</p>

<p>{{ text1 }} <a [attr.href]='url'>{{ text2 }}</a></p>